<template functional>
    <div class="lotto-event-row__header-wrapper">
        <div
            v-if="!!props.eventDate"
            class="lotto-event-row__header-info-date"
        >
            {{ props.eventDate | formatDateTime('wddHHMM') }}
        </div>
        <div class="lotto-event-row__details">
            <span class="lotto-event-row__header-info-name">
                {{ props.eventName }}
            </span>
            <span class="lotto-game-logo">
                <span class="lotto-game-logo__guesses">{{ props.numbersDrawn }}</span>
                <span class="lotto-game-logo__total">{{ props.totalNumbers }}</span>
            </span>
            <span
                v-if="eventNumbers"
                class="lotto-game-logo"
            >
                {{ props.eventNumbers }}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LottoHeading',
        functional: true,
        props: {
            eventName: {
                type: String,
                required: true
            },
            numbersDrawn: {
                type: Number,
                required: true
            },
            totalNumbers: {
                type: Number,
                required: true
            },
            eventNumbers: {
                type: String,
                required: false,
                default: ''
            },
            eventDate: {
                type: Date,
                required: false,
                default: null
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/lotto/shared/LottoHeading.vue